import { FormEvent, ReactNode } from 'react'
import { WideFormContainer, WideFormContent } from './WideForm.styles'

interface WideFormProps {
  controlParam?: boolean
  title?: string
  onSubmit: () => void
  children: ReactNode
  fullHeight?: boolean
  shouldExpand?: boolean
}

export function WideForm({
  controlParam = false,
  title,
  onSubmit,
  children,
  fullHeight = false,
  shouldExpand = true,
}: WideFormProps) {
  function handleSubmit(event: FormEvent): void {
    event.preventDefault()
    if (!controlParam) {
      onSubmit()
    }
  }

  return (
    <WideFormContainer onSubmit={handleSubmit} $fullHeight={fullHeight} $shouldExpand={shouldExpand}>
      {title && <h1>{title}</h1>}
      <WideFormContent $fullHeight={fullHeight} $shouldExpand={shouldExpand}>
        {children}
      </WideFormContent>
    </WideFormContainer>
  )
}

export { WideFormContent } from './WideForm.styles'
